/**
 * Servis manzillari.
 *
 * Har bir mikroservis o'z portida turadi. Ishlab chiqarishda ular
 * bitta gateway ortiga yig'iladi, shuning uchun manzillar BITTA
 * joyda: gateway ulanganda faqat shu fayl o'zgaradi.
 */
export const SERVICES = {
  identity: "http://localhost:8081",
  masterData: "http://localhost:8082",
  topology: "http://localhost:8083",
  inventory: "http://localhost:8084",
  task: "http://localhost:8085",
  putaway: "http://localhost:8086",
  replenishment: "http://localhost:8087",
  inbound: "http://localhost:8088",
  picking: "http://localhost:8089",
  control: "http://localhost:8090",
  shipping: "http://localhost:8091",
  count: "http://localhost:8092",
  production: "http://localhost:8093",
  reporting: "http://localhost:8094",
  notification: "http://localhost:8095",
  media: "http://localhost:8096",
  audit: "http://localhost:8097",
  config: "http://localhost:8098",
  integration: "http://localhost:8100",
} as const;

export type ServiceName = keyof typeof SERVICES;

const OVERRIDE_KEY = "uyda.gateway";

/** Prod paketi (gateway ortida) — `VITE_SAME_ORIGIN=1` bilan quriladi. */
const SAME_ORIGIN = import.meta.env.VITE_SAME_ORIGIN === "1";

/**
 * Desktop paketiga qurishda yoziladigan gateway manzili:
 * `VITE_UYDA_GATEWAY=https://uyda.wms.kairum.uz`.
 *
 * Electron rendererni `file://` dan ochadi, shuning uchun u yerda
 * `VITE_SAME_ORIGIN` ISHLAMAYDI — `window.location.origin` `file://`
 * bo'lib chiqadi va hamma so'rov yiqiladi. Brauzer paketida bu
 * o'zgaruvchi berilmaydi va hech narsa o'zgarmaydi.
 */
const BUILD_GATEWAY = (import.meta.env.VITE_UYDA_GATEWAY ?? "").replace(/\/$/, "");

/**
 * Servis manzilini qaytaradi.
 *
 * Gateway manzili berilgan bo'lsa HAMMASI shu manzilga yo'naltiriladi:
 * ishlab chiqarishda servislar alohida portlarda ko'rinmaydi.
 */
export function baseUrl(service: ServiceName): string {
  const gateway = localStorage.getItem(OVERRIDE_KEY);
  if (gateway) return gateway.replace(/\/$/, "");
  if (BUILD_GATEWAY) return BUILD_GATEWAY;
  // Prod paketi gateway ortida turadi: sahifa qaysi manzildan ochilgan
  // bo'lsa, API ham o'sha manzilda (deploy/single-node, `VITE_SAME_ORIGIN=1`).
  if (SAME_ORIGIN) return window.location.origin;
  return SERVICES[service];
}
